import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';
import { PaletteConfigProvider } from 'palette/Config';
import { ModalContextProvider } from 'palette/Modal';
import { ToastContextProvider } from 'palette/Toast';
import { ConfigProvider } from '@common/Config';
import { TranslationsProvider, useTranslate } from '@common/Translations';
import { getStoreEnv } from '@helpers/env';
import { STORE_NAME, PALETTE_DEVICE_BY_ENV } from './constants';

function ReactOnRailsRootComponent(Component, { withReduxStore = false } = {}) {
    function PaletteConfigSection({ context, props }) {
        const { env, SVGURL } = context;
        const translate = useTranslate();

        return (
            <PaletteConfigProvider
                device={PALETTE_DEVICE_BY_ENV[env]}
                logoPath={SVGURL}
                svgPath={SVGURL}
                theme={getStoreEnv(context)}
                translate={translate}
            >
                <ModalContextProvider>
                    <ToastContextProvider>
                        <Component {...props} />
                    </ToastContextProvider>
                </ModalContextProvider>
            </PaletteConfigProvider>
        );
    }

    function BaseContextProviders({ props, context }) {
        const { config } = props;

        return (
            <ConfigProvider
                config={config}
                context={context}
            >
                <TranslationsProvider context={context}>
                    <PaletteConfigSection
                        context={context}
                        props={props}
                    />
                </TranslationsProvider>
            </ConfigProvider>
        );
    }

    return function ReactOnRailsContextProvider(props, context) {
        return function ReactOnRailsRootWrapper() {
            return (withReduxStore && typeof DISABLE_RAILS === 'undefined') ? (
                <Provider store={ReactOnRails.getStore(STORE_NAME)}>
                    <BaseContextProviders
                        context={context}
                        props={props}
                    />
                </Provider>
            ) : (
                <BaseContextProviders
                    context={context}
                    props={props}
                />
            );
        };
    };
}

export default ReactOnRailsRootComponent;
